import React from 'react'
import { useWorkspaceActivityLog } from '../hooks/useWorkspaceActivityLog.js'
import ActivityLogDrawer from './ActivityLogDrawer.js'

interface Props {
  workspaceId: string | null
  workspaceName?: string
  onClose: () => void
}

const WorkspaceActivityDrawer: React.FC<Props> = ({ workspaceId, workspaceName, onClose }) => {
  const activityLog = useWorkspaceActivityLog(workspaceId)

  return (
    <ActivityLogDrawer
      entityId={workspaceId}
      title="Activity Log"
      {...(workspaceName ? { subtitle: workspaceName } : {})}
      noSessionsLabel="No AI tool calls yet for this workspace."
      onClose={onClose}
      {...activityLog}
    />
  )
}

export default WorkspaceActivityDrawer
